// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.JRuSpYNXg42LDNbzobT9, .GVrdSAefXOb6_0IO7sKb, .ujuZK4_3giH7My7Ky2BW, .ybJRhniL4SkPQassT4Xh, .X9TaPmOFH1RkEE7EMyI9, .Q7uTxHXnNmz7aGhAQCJf {
  max-width: 100%;
  width: fit-content;
  white-space: pre;
  height: 48px;
  border-radius: 8px;
  font-family: "Chakra Petch";
  font-weight: 700;
  font-size: 17px;
  line-height: 28px;
  border: 1px solid transparent;
  transition: all 0.2s ease-in-out;
  text-transform: uppercase;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  min-width: fit-content;
  cursor: pointer;
}
@media (max-width: 1200px) {
  .JRuSpYNXg42LDNbzobT9, .GVrdSAefXOb6_0IO7sKb, .ujuZK4_3giH7My7Ky2BW, .ybJRhniL4SkPQassT4Xh, .X9TaPmOFH1RkEE7EMyI9, .Q7uTxHXnNmz7aGhAQCJf {
    padding-left: 12px;
    padding-right: 12px;
  }
}
.JRuSpYNXg42LDNbzobT9 > .Wmgj2OmwS0H1i8V5hgLI, .GVrdSAefXOb6_0IO7sKb > .Wmgj2OmwS0H1i8V5hgLI, .ujuZK4_3giH7My7Ky2BW > .Wmgj2OmwS0H1i8V5hgLI, .ybJRhniL4SkPQassT4Xh > .Wmgj2OmwS0H1i8V5hgLI, .X9TaPmOFH1RkEE7EMyI9 > .Wmgj2OmwS0H1i8V5hgLI, .Q7uTxHXnNmz7aGhAQCJf > .Wmgj2OmwS0H1i8V5hgLI {
  transition: all 0.2s ease-in-out;
  margin: auto 0 auto 15px;
}
.JRuSpYNXg42LDNbzobT9 > .mygLYpEQ4LTJ2SZszvJV, .GVrdSAefXOb6_0IO7sKb > .mygLYpEQ4LTJ2SZszvJV, .ujuZK4_3giH7My7Ky2BW > .mygLYpEQ4LTJ2SZszvJV, .ybJRhniL4SkPQassT4Xh > .mygLYpEQ4LTJ2SZszvJV, .X9TaPmOFH1RkEE7EMyI9 > .mygLYpEQ4LTJ2SZszvJV, .Q7uTxHXnNmz7aGhAQCJf > .mygLYpEQ4LTJ2SZszvJV {
  margin: 0 15px 0 0 !important;
}
.JRuSpYNXg42LDNbzobT9:hover, .GVrdSAefXOb6_0IO7sKb:hover, .ujuZK4_3giH7My7Ky2BW:hover, .ybJRhniL4SkPQassT4Xh:hover, .X9TaPmOFH1RkEE7EMyI9:hover, .Q7uTxHXnNmz7aGhAQCJf:hover {
  color: #48CAE4;
}
.JRuSpYNXg42LDNbzobT9[disabled]:hover, [disabled].GVrdSAefXOb6_0IO7sKb:hover, [disabled].ujuZK4_3giH7My7Ky2BW:hover, [disabled].ybJRhniL4SkPQassT4Xh:hover, [disabled].X9TaPmOFH1RkEE7EMyI9:hover, [disabled].Q7uTxHXnNmz7aGhAQCJf:hover {
  cursor: not-allowed;
  color: white;
}
.JRuSpYNXg42LDNbzobT9[disabled]:hover > .Wmgj2OmwS0H1i8V5hgLI, [disabled].GVrdSAefXOb6_0IO7sKb:hover > .Wmgj2OmwS0H1i8V5hgLI, [disabled].ujuZK4_3giH7My7Ky2BW:hover > .Wmgj2OmwS0H1i8V5hgLI, [disabled].ybJRhniL4SkPQassT4Xh:hover > .Wmgj2OmwS0H1i8V5hgLI, [disabled].X9TaPmOFH1RkEE7EMyI9:hover > .Wmgj2OmwS0H1i8V5hgLI, [disabled].Q7uTxHXnNmz7aGhAQCJf:hover > .Wmgj2OmwS0H1i8V5hgLI {
  fill: white;
}

.Q7uTxHXnNmz7aGhAQCJf {
  color: white;
  border: 1px solid white;
  background: transparent;
}
.Q7uTxHXnNmz7aGhAQCJf > .Wmgj2OmwS0H1i8V5hgLI {
  fill: white;
}
.Q7uTxHXnNmz7aGhAQCJf[disabled] {
  cursor: not-allowed;
  background: #c4c4c4;
  border: 1px solid #c4c4c4;
}
.Q7uTxHXnNmz7aGhAQCJf[disabled]:hover {
  color: #003049;
}
.Q7uTxHXnNmz7aGhAQCJf[disabled]:hover > .Wmgj2OmwS0H1i8V5hgLI {
  fill: initial;
}

.X9TaPmOFH1RkEE7EMyI9 {
  background: #FFFFFF;
  border: 1px solid #FFFFFF;
  box-sizing: border-box;
  box-shadow: inset 0px 2px px #FFFFFF, inset 0px -4px 4px rgba(0, 48, 73, 0.25), inset 0px 0px 25px #FFFFFF;
  border-radius: 8px;
  font-family: Chakra Petch;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  text-align: center;
  font-feature-settings: "pnum" on, "lnum" on;
  color: #003049;
}
.X9TaPmOFH1RkEE7EMyI9:hover {
  color: #48CAE4;
}
.X9TaPmOFH1RkEE7EMyI9 > .Wmgj2OmwS0H1i8V5hgLI {
  fill: #003049;
  stroke: #003049;
}
.X9TaPmOFH1RkEE7EMyI9 > .mygLYpEQ4LTJ2SZszvJV {
  margin: 0 15px 0 0 !important;
}
.X9TaPmOFH1RkEE7EMyI9[disabled] {
  cursor: not-allowed;
  background: #c4c4c4;
  border: 1px solid #c4c4c4;
}
.X9TaPmOFH1RkEE7EMyI9[disabled]:hover {
  color: #003049;
}
.ybJRhniL4SkPQassT4Xh {
  background: rgba(0, 48, 73, 0.95);
  font-weight: 500;
  color: white;
}
.ybJRhniL4SkPQassT4Xh:hover {
  color: #48CAE4;
}
.ybJRhniL4SkPQassT4Xh:active {
  background: linear-gradient(180deg, rgba(0, 48, 73, 0.6) 21.35%, rgba(0, 48, 73, 0.48) 69.79%, rgba(72, 202, 228, 0.36) 100%);
}

.ujuZK4_3giH7My7Ky2BW {
  background: rgba(67, 54, 120, 0.95);
  font-weight: 500;
  color: white;
}
.ujuZK4_3giH7My7Ky2BW:hover {
  color: #48CAE4;
}
.ujuZK4_3giH7My7Ky2BW:active {
  background: linear-gradient(180deg, rgba(141, 113, 255, 0.6) 21.35%, rgba(141, 113, 255, 0.48) 69.79%, rgba(72, 202, 228, 0.36) 100%);
}

.GVrdSAefXOb6_0IO7sKb {
  background: rgba(0, 209, 140, 0.95);
  font-weight: 500;
  color: white;
}
.GVrdSAefXOb6_0IO7sKb:hover {
  color: #48CAE4;
}
.GVrdSAefXOb6_0IO7sKb:active {
  background: linear-gradient(180deg, rgba(0, 209, 140, 0.6) 21.35%, rgba(0, 209, 140, 0.48) 69.79%, rgba(72, 202, 228, 0.36) 100%);
}`, "",{"version":3,"sources":["webpack://./src/Components/Button/Button.module.scss"],"names":[],"mappings":"AACA;EACC,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,2BAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,6BAAA;EACA,gCAAA;EACA,yBAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,eAAA;AAAD;AAEC;EAnBD;IAoBE,kBAAA;IACA,mBAAA;EACA;AACF;AAEC;EACC,gCAAA;EACA,wBAAA;AAAF;AAGC;EACC,6BAAA;AADF;AAIC;EACC,cAAA;AAFF;AASC;EACC,mBAAA;EACA,YAAA;AAPF;AASE;EACC,WAAA;AAPH;;AAYA;EAGC,YAAA;EACA,uBAAA;EACA,uBAAA;AAXD;AAaC;EACC,WAAA;AAXF;AAaC;EACC,mBAAA;EACA,mBAAA;EACA,yBAAA;AAXF;AAYE;EACC,cAAA;AAVH;AAWG;EACC,aAAA;AATJ;;AAgBA;EAIC,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,0GAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;EACA,2CAAA;EACA,cAAA;AAhBD;AAiBC;EACC,cAAA;AAfF;AAkBC;EACC,aAAA;EACA,eAAA;AAhBF;AAmBC;EACC,6BAAA;AAjBF;AAmBC;EACC,mBAAA;EACA,mBAAA;EACA,yBAAA;AAjBF;AAkBE;EACC,cAAA;AAhBH;AAyBA;EAEC,iCAAA;EACA,gBAAA;EACA,YAAA;AAxBD;AAyBC;EACC,cAAA;AAvBF;AAyBC;EACC,6HAAA;AAvBF;;AA2BA;EAEC,mCAAA;EACA,gBAAA;EACA,YAAA;AAzBD;AA0BC;EACC,cAAA;AAxBF;AA0BC;EACC,qIAAA;AAxBF;;AA4BA;EAEC,mCAAA;EACA,gBAAA;EACA,YAAA;AA1BD;AA2BC;EACC,cAAA;AAzBF;AA2BC;EACC,iIAAA;AAzBF","sourcesContent":["\r\n.button {\r\n\tmax-width: 100%;\r\n\twidth: fit-content;\r\n\twhite-space: pre;\r\n\theight: 48px;\r\n\tborder-radius: 8px;\r\n\tfont-family: \"Chakra Petch\";\r\n\tfont-weight: 700;\r\n\tfont-size: 17px;\r\n\tline-height: 28px;\r\n\tborder: 1px solid transparent;\r\n\ttransition: all 0.2s ease-in-out;\r\n\ttext-transform: uppercase;\r\n\tflex-direction: row;\r\n\tjustify-content: center;\r\n\talign-items: center;\r\n\tmin-width: fit-content;\r\n\tcursor: pointer;\r\n\r\n\t@media (max-width: 1200px ) {\r\n\t\tpadding-left: 12px;\r\n\t\tpadding-right: 12px;\r\n\t}\r\n\r\n\r\n\t& > .buttonIcon {\r\n\t\ttransition: all 0.2s ease-in-out;\r\n\t\tmargin: auto 0 auto 15px;\r\n\t}\r\n\r\n\t& > .leftIcon {\r\n\t\tmargin: 0 15px 0 0 !important;\r\n\t}\r\n\r\n\t&:hover {\r\n\t\tcolor: #48CAE4;\r\n\r\n\t\t& > .buttonIcon {\r\n\r\n\t\t}\r\n\t}\r\n\r\n\t&[disabled]:hover {\r\n\t\tcursor: not-allowed;\r\n\t\tcolor: white;\r\n\r\n\t\t& > .buttonIcon {\r\n\t\t\tfill: white;\r\n\t\t}\r\n\t}\r\n}\r\n\r\n.primary {\r\n\t@extend .button;\r\n\r\n\tcolor: white;\r\n\tborder: 1px solid white;\r\n\tbackground: transparent;\r\n\r\n\t& > .buttonIcon {\r\n\t\tfill: white;\r\n\t}\r\n\t&[disabled] {\r\n\t\tcursor: not-allowed;\r\n\t\tbackground: #c4c4c4;\r\n\t\tborder: 1px solid #c4c4c4;\r\n\t\t&:hover {\r\n\t\t\tcolor: #003049;\r\n\t\t\t& > .buttonIcon {\r\n\t\t\t\tfill: initial;\r\n\t\t\t}\r\n\t\t}\r\n\r\n\t}\r\n}\r\n\r\n.primaryLight {\r\n\t@extend .button;\r\n\r\n\r\n\tbackground: #FFFFFF;\r\n\tborder: 1px solid #FFFFFF;\r\n\tbox-sizing: border-box;\r\n\tbox-shadow: inset 0px 2px px #FFFFFF, inset 0px -4px 4px rgba(0, 48, 73, 0.25), inset 0px 0px 25px #FFFFFF;\r\n\tborder-radius: 8px;\r\n\tfont-family: Chakra Petch;\r\n\tfont-style: normal;\r\n\tfont-weight: bold;\r\n\tfont-size: 18px;\r\n\ttext-align: center;\r\n\tfont-feature-settings: 'pnum' on, 'lnum' on;\r\n\tcolor: #003049;\r\n\t&:hover {\r\n\t\tcolor: #48CAE4;\r\n\t}\r\n\r\n\t& > .buttonIcon {\r\n\t\tfill: #003049;\r\n\t\tstroke: #003049;\r\n\t}\r\n\r\n\t& > .leftIcon {\r\n\t\tmargin: 0 15px 0 0 !important;\r\n\t}\r\n\t&[disabled] {\r\n\t\tcursor: not-allowed;\r\n\t\tbackground: #c4c4c4;\r\n\t\tborder: 1px solid #c4c4c4;\r\n\t\t&:hover {\r\n\t\t\tcolor: #003049;\r\n\t\t\t& > .buttonIcon {\r\n\t\t\t\t//fill: initial;\r\n\t\t\t}\r\n\t\t}\r\n\r\n\t}\r\n}\r\n\r\n.secondary  {\r\n\t@extend .button;\r\n\tbackground: rgba(0, 48, 73, 0.95);\r\n\tfont-weight: 500;\r\n\tcolor: white;\r\n\t&:hover {\r\n\t\tcolor: #48CAE4;\r\n\t}\r\n\t&:active {\r\n\t\tbackground: linear-gradient(180deg, rgba(0, 48, 73, 0.6) 21.35%, rgba(0, 48, 73, 0.48) 69.79%, rgba(72, 202, 228, 0.36) 100%);\r\n\t}\r\n}\r\n\r\n.secondaryPurple {\r\n\t@extend .button;\r\n\tbackground: rgba(67, 54, 120, 0.95);\r\n\tfont-weight: 500;\r\n\tcolor: white;\r\n\t&:hover {\r\n\t\tcolor: #48CAE4;\r\n\t}\r\n\t&:active {\r\n\t\tbackground: linear-gradient(180deg, rgba(141, 113, 255, 0.6) 21.35%, rgba(141, 113, 255, 0.48) 69.79%, rgba(72, 202, 228, 0.36) 100%);\r\n\t}\r\n}\r\n\r\n.secondaryGreen {\r\n\t@extend .button;\r\n\tbackground: rgba(0, 209, 140, 0.95);\r\n\tfont-weight: 500;\r\n\tcolor: white;\r\n\t&:hover {\r\n\t\tcolor: #48CAE4;\r\n\t}\r\n\t&:active {\r\n\t\tbackground: linear-gradient(180deg, rgba(0, 209, 140, 0.6) 21.35%, rgba(0, 209, 140, 0.48) 69.79%, rgba(72, 202, 228, 0.36) 100%);\r\n\t}\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `JRuSpYNXg42LDNbzobT9`,
	"secondaryGreen": `GVrdSAefXOb6_0IO7sKb`,
	"secondaryPurple": `ujuZK4_3giH7My7Ky2BW`,
	"secondary": `ybJRhniL4SkPQassT4Xh`,
	"primaryLight": `X9TaPmOFH1RkEE7EMyI9`,
	"primary": `Q7uTxHXnNmz7aGhAQCJf`,
	"buttonIcon": `Wmgj2OmwS0H1i8V5hgLI`,
	"leftIcon": `mygLYpEQ4LTJ2SZszvJV`
};
export default ___CSS_LOADER_EXPORT___;
